import { css as c, LitElement as m, nothing as i, html as f } from "lit";
import { query as y, property as r, state as b, customElement as v } from "lit/decorators.js";
import { classMap as g } from "lit/directives/class-map.js";
import { live as x } from "lit/directives/live.js";
import { b as w, f as $ } from "./styles-scZ6dVz-.js";
import { b as p, a as l } from "./events-CkEPl0SM.js";
import { g as S } from "./a11y-DxQW21Jt.js";
var z = Object.defineProperty, k = Object.getOwnPropertyDescriptor, e = (a, o, u, n) => {
  for (var s = n > 1 ? void 0 : n ? k(o, u) : o, d = a.length - 1, h; d >= 0; d--)
    (h = a[d]) && (s = (n ? h(o, u, s) : h(s)) || s);
  return n && s && z(o, u, s), s;
};
let t = class extends m {
  constructor() {
    super(...arguments), this.inputId = S("ark-input"), this.value = "", this.type = "text", this.size = "md", this.disabled = !1, this.readonly = !1, this.required = !1, this.invalid = !1, this.ariaLabel = null, this.autofocus = !1, this.hasFocus = !1;
  }
  /** Focus the input */
  focus(a) {
    this.inputElement?.focus(a);
  }
  /** Blur the input */
  blur() {
    this.inputElement?.blur();
  }
  /** Select all text */
  select() {
    this.inputElement?.select();
  }
  handleInput(a) {
    const o = a.target;
    this.value = o.value, p(this, l.INPUT, { value: this.value });
  }
  handleChange(a) {
    const o = a.target;
    this.value = o.value, p(this, l.CHANGE, { value: this.value });
  }
  handleFocus() {
    this.hasFocus = !0, p(this, l.FOCUS);
  }
  handleBlur() {
    this.hasFocus = !1, p(this, l.BLUR);
  }
  render() {
    const a = {
      wrapper: !0,
      [this.size]: !0,
      disabled: this.disabled,
      readonly: this.readonly,
      invalid: this.invalid,
      focused: this.hasFocus
    };
    return f`
      <div part="wrapper" class=${g(a)}>
        <span part="prefix" class="prefix">
          <slot name="prefix"></slot>
        </span>

        <input
          part="input"
          id=${this.inputId}
          type=${this.type}
          name=${this.name ?? i}
          .value=${x(this.value)}
          placeholder=${this.placeholder ?? i}
          ?disabled=${this.disabled}
          ?readonly=${this.readonly}
          ?required=${this.required}
          ?autofocus=${this.autofocus}
          aria-label=${this.ariaLabel ?? i}
          inputmode=${this.inputmode ?? i}
          min=${this.min ?? i}
          max=${this.max ?? i}
          step=${this.step ?? i}
          minlength=${this.minlength ?? i}
          maxlength=${this.maxlength ?? i}
          pattern=${this.pattern ?? i}
          autocomplete=${this.autocomplete ?? i}
          aria-invalid=${this.invalid ? "true" : i}
          @input=${this.handleInput}
          @change=${this.handleChange}
          @focus=${this.handleFocus}
          @blur=${this.handleBlur}
        />

        <span part="suffix" class="suffix">
          <slot name="suffix"></slot>
        </span>
      </div>
    `;
  }
};
t.styles = [
  w,
  $,
  c`
      :host {
        display: block;
      }

      .wrapper {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        background-color: var(--r5-bg);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-md);
        transition-property: border-color, box-shadow;
        transition-duration: var(--r5-duration-fast);
        transition-timing-function: var(--r5-ease-default);
        overflow: hidden;
      }

      .wrapper:focus-within {
        border-color: var(--r5-border-focus);
        box-shadow: 0 0 0 var(--r5-focus-ring-width) var(--r5-color-primary-100);
      }

      .wrapper.invalid {
        border-color: var(--r5-color-danger-500);
      }

      .wrapper.invalid:focus-within {
        box-shadow: 0 0 0 var(--r5-focus-ring-width) var(--r5-color-danger-100);
      }

      .wrapper.disabled {
        background-color: var(--r5-bg-muted);
        opacity: 0.5;
        cursor: not-allowed;
      }

      .wrapper.readonly {
        background-color: var(--r5-bg-subtle);
      }

      /* Sizes */
      .sm {
        min-height: var(--r5-input-height-sm);
        padding: 0 var(--r5-space-2);
        font-size: var(--r5-text-xs);
      }

      .md {
        min-height: var(--r5-input-height-md);
        padding: 0 var(--r5-space-3);
        font-size: var(--r5-text-sm);
      }

      .lg {
        min-height: var(--r5-input-height-lg);
        padding: 0 var(--r5-space-4);
        font-size: var(--r5-text-base);
      }

      input {
        flex: 1;
        min-width: 0;
        border: none;
        background: transparent;
        color: var(--r5-text);
        font-family: inherit;
        font-size: inherit;
        outline: none;
        padding: 0;
      }

      input::placeholder {
        color: var(--r5-text-muted);
      }

      input:disabled {
        cursor: not-allowed;
      }

      /* Prefix and suffix */
      .prefix,
      .suffix {
        display: flex;
        align-items: center;
        color: var(--r5-text-muted);
      }

      ::slotted([slot='prefix']),
      ::slotted([slot='suffix']) {
        display: inline-flex;
        align-items: center;
      }

      /* Hide number input spinners */
      input[type='number']::-webkit-outer-spin-button,
      input[type='number']::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      input[type='number'] {
        -moz-appearance: textfield;
      }

      /* Hide search cancel button */
      input[type='search']::-webkit-search-cancel-button {
        -webkit-appearance: none;
      }
    `
];
e([
  y("input")
], t.prototype, "inputElement", 2);
e([
  r({ type: String })
], t.prototype, "value", 2);
e([
  r({ type: String })
], t.prototype, "type", 2);
e([
  r({ type: String, reflect: !0 })
], t.prototype, "size", 2);
e([
  r({ type: String })
], t.prototype, "placeholder", 2);
e([
  r({ type: Boolean, reflect: !0 })
], t.prototype, "disabled", 2);
e([
  r({ type: Boolean, reflect: !0 })
], t.prototype, "readonly", 2);
e([
  r({ type: Boolean, reflect: !0 })
], t.prototype, "required", 2);
e([
  r({ type: Boolean, reflect: !0 })
], t.prototype, "invalid", 2);
e([
  r({ type: String })
], t.prototype, "name", 2);
e([
  r({ type: String, attribute: "aria-label" })
], t.prototype, "ariaLabel", 2);
e([
  r({ type: String, attribute: "inputmode" })
], t.prototype, "inputmode", 2);
e([
  r({ type: Number })
], t.prototype, "min", 2);
e([
  r({ type: Number })
], t.prototype, "max", 2);
e([
  r({ type: Number })
], t.prototype, "step", 2);
e([
  r({ type: Number })
], t.prototype, "minlength", 2);
e([
  r({ type: Number })
], t.prototype, "maxlength", 2);
e([
  r({ type: String })
], t.prototype, "pattern", 2);
e([
  r({ type: String })
], t.prototype, "autocomplete", 2);
e([
  r({ type: Boolean })
], t.prototype, "autofocus", 2);
e([
  b()
], t.prototype, "hasFocus", 2);
t = e([
  v("ark-input")
], t);
export {
  t as A
};
//# sourceMappingURL=ark-input-DLb_kkBs.js.map
